var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-invisible-scroll",class:[
    { 'disable-events': _vm.isGrabStarted },
    _vm.isGrabbing ? 'is-grabbing u-disable-selection' : '', _vm.hasDrag ? 'u-cursor-grab' : '',
    _vm.$device.isTouch ? 'u-overflow-x-scroll' : ''
  ],on:{"mousedown":_vm.onMouseDown,"mousemove":_vm.onMouseMove,"mouseup":_vm.onMouseEnd,"mouseleave":_vm.onMouseEnd,"touchstart":_vm.onMouseDown,"touchmove":_vm.onMouseMove,"touchend":_vm.onMouseEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }